import { createContext, useContext } from "react";
import type { MemberShellPlacement } from "@/lib/member-shell";

/* 頁が今どの外枠の中にいるか。frame なら頁が自分で描く公開の帯とフッターを出さない */
export const MemberShellContext = createContext<MemberShellPlacement>("none");

export function useMemberShell(): MemberShellPlacement {
  return useContext(MemberShellContext);
}
